import Vue from 'vue'
import VueRouter from 'vue-router'

import Main from '../views'
import Tariffs from '../views/tariffs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Main,
    meta: {
      title: 'Главная',
    },
  },
  {
    path: '/tariffs',
    component: Tariffs,
    meta: {
      title: 'Тарифы',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes
})

export default router
